/* Redux-Toolkit */

import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

interface ScrollState {
  isScrolling: boolean;
  scrollPosition: number;
}

const initialState: ScrollState = {
  isScrolling: false,
  scrollPosition: 0,
};

export const scrollSlice = createSlice({
  name: "scroll",
  initialState,
  reducers: {
    setIsScrolling: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isScrolling = action.payload;
    },
    setScrollPosition: (
      state,
      action: PayloadAction<number>
    ) => {
      state.scrollPosition = action.payload;
    },
  },
});

/* Actions */
export const { setIsScrolling, setScrollPosition } =
  scrollSlice.actions;

/* Reducer */
export default scrollSlice.reducer;
